export const REPORT_RESET_REQUEST = "REPORT_RESET_REQUEST";
export const REPORT_GET_STATUS = "REPORT_GET_STATUS";
export const REPORT_EMAIL = "REPORT_EMAIL";
export const REPORT_DELETE = "REPORT_DELETE";
export const REPORT_PUBLISH = "REPORT_PUBLISH";
